import { challengeMapIdToNumber, isChallengeMapId } from "@dailywars/core/engine";
import { Link } from "@tanstack/react-router";

import { Button } from "#/components/ui/button";

export function GameOverLeaderboardLink({ mapId }: { mapId: string }) {
  if (isChallengeMapId(mapId)) {
    const challengeNumber = String(challengeMapIdToNumber(mapId));
    return (
      <Link
        to="/challenge/$challengeNumber/leaderboard"
        params={{ challengeNumber }}
        preload={false}
        className="w-full"
      >
        <Button variant="accent" size="lg" className="w-full">
          Leaderboard
        </Button>
      </Link>
    );
  }
  return (
    <Link to="/leaderboard/$mapId" params={{ mapId }} preload={false} className="w-full">
      <Button variant="accent" size="lg" className="w-full">
        Leaderboard
      </Button>
    </Link>
  );
}
